import * as React from "react";

import { BlockProps } from "baseui/block";
import { DisplayLabel } from "./DisplayLabel";
import { useFormatter } from "../useFormatter";

export type TDateDisplay = {
  answer: Date;
} & BlockProps;
export const DateDisplay: React.FC<TDateDisplay> = ({ answer, ...restProps }) => {
  const { formatDate } = useFormatter();
  const formattedValue = formatDate(answer);
  return <DisplayLabel {...restProps}>{formattedValue}</DisplayLabel>;
};
